const { componentResolverFromMap } = require("gatsby-plugin-prismic-previews")
const React = require("react")

// For v5 of gatsby-plugin-prismic-previews, we need to pass lazy-loaded components
// wrapped in React.lazy() to avoid Promise rendering issues
const componentMap = {
  home: React.lazy(() => import("../pages/index")),
  services: React.lazy(() => import("../pages/services")),
  services_page: React.lazy(() => import("../Templates/servicesTemplate")),
  consulting: React.lazy(() => import("../pages/consulting")),
  consulting_page: React.lazy(() => import("../Templates/consultingTemplate")),
  technologies: React.lazy(() => import("../pages/technologies")),
  technologies_page: React.lazy(() => import("../pages/technologies")),
  single_technologies_page: React.lazy(() => import("../Templates/technologiesTemplate")),
  blog: React.lazy(() => import("../pages/blog")),
  blog_post: React.lazy(() => import("../Templates/blogPostTemplate")),
  case_studies: React.lazy(() => import("../pages/case-studies")),
  case_studies_post: React.lazy(() => import("../Templates/caseStudiesPostTemplate")),
  author: React.lazy(() => import("../Templates/authorTemplate")),
  authors: React.lazy(() => import("../pages/blog/authors")),
  pdf_marketing_pages: React.lazy(() => import("../Templates/pdfMarketingTemplate")),
  privacy_policy: React.lazy(() => import("../pages/privacy-policy")),
  terms_of_use_page: React.lazy(() => import("../pages/terms-of-use")),
  reviews: React.lazy(() => import("../pages/reviews")),
  careers: React.lazy(() => import("../pages/careers")),
  about: React.lazy(() => import("../pages/about")),
}

console.log("[ComponentResolver] Creating component resolver with types:", Object.keys(componentMap))

const componentResolver = componentResolverFromMap(componentMap)

console.log("[ComponentResolver] Component resolver result:", componentResolver)
console.log("[ComponentResolver] Component resolver type:", typeof componentResolver)

module.exports = {
  componentResolver,
}
